import { Component, OnInit } from '@angular/core';
import { WebsocketService } from '../../../services/websocket/websocket.service';
import { SnotifyService } from 'ng-snotify';
import { LinkService } from '../../../services/link/link.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { concat } from 'rxjs';

@Component({
    selector: 'app-monitor-list-links',
    templateUrl: './monitor-links.component.html',
    styleUrls: ['./monitor-links.component.scss'],
})
export class MonitorLinksComponent implements OnInit {

    public loading = false;

    public currentDominio: string = null;

    public listaLinksByDominio: Array<any> = [];

    public openedModal: boolean = false;

    public selectedLink = {};

    public selectedLinkDelete = [];

    constructor(
        private websocket: WebsocketService,
        private _notify: SnotifyService,
        private linkService: LinkService,
        private spinner: NgxSpinnerService
    ) {
    }

    public listaLinks: Array<any> = [];

    public lastResponse = null;

    public lastResponseModal = null;

    public currentPage = 1;

    public currentPageModal = 1;

    public perPage: string|number = 100;

    public perPageModal: string|number = 10;

    ngOnInit() {
        this._loadLinks();
    }

    private _loadLinks(page: string|number = 1): void {
        this.loading = true;
        this.spinner.show();
        this.linkService.listar(null, page, this.perPage).subscribe(
            ({data}) => {
                this.loading = false;
                this.lastResponse = data.links;
                this.listaLinks = this.listaLinks.concat(data.links.data);
                this.spinner.hide();
            },
            error => {
                this._notify.error('Ocorreu um erro ao listar dados');
                this.loading = false;
            }
        );
    }

    public loadMore(): void {
        this.currentPage++;
        this._loadLinks(this.currentPage);
    }

    public loadPerPage($event) {
        this.perPage = $event.target.value;
        this.reset(false);
        this._loadLinks();
    }

    public reset(reload: boolean): void {
        this.listaLinks = [];
        this.currentPage = 1;

        if (reload) {
            this._loadLinks();
        }
    }

    public toFilter() {
        this.reset(false);
        this._loadLinks();
    }

    public showAllLinks(url: string): void {
        this.currentDominio = url;
        this.carregamentoLink(this.currentDominio);
    }

    public deleteLink(dominio): void {
        if (confirm(`Tem certeza que deseja marcar este(s) domínio(s) como inválido(s)?`)) {
            this.spinner.show();
            this.linkService.deletarLink(dominio).subscribe( response => {
                this.spinner.hide();
                this._notify.success('Domínio excluído com sucesso');
                this.reset(true);
                this.closeModal();
            }, error => {
                console.error(error);
                this._notify.error('Erro ao carregar links do dominio');
                this.spinner.hide();
            });
        }
    }

    public carregamentoLink(dominio, page: string|number = 1): void {
        this.spinner.show();
        this.linkService.listarByDominio(dominio, page, this.perPageModal).subscribe(
            ({data}) => {
                this.spinner.hide();
                this.lastResponseModal = data.links;
                this.listaLinksByDominio = this.listaLinksByDominio.concat(data.links.data)
                this.openModal();
            },
            error => {
                this._notify.error('Ocorreu um erro ao listar dados');
                this.spinner.hide();

            }
        );
    }

    public loadMoreCarregarLinkModal(url, reset = false) {
        if (reset) {
            this.currentPageModal = 0;
            this.listaLinksByDominio = [];
        }
        this.currentPageModal++;
        this.carregamentoLink(url, this.currentPageModal);
    }

    public closeModal(): void {
        this.openedModal = false;
        this.listaLinksByDominio = [];
    }

    public openModal(): void {
        this.openedModal = true;
    }

    public addRemoveLinkDelete(): void {
        this.selectedLinkDelete = Object.keys(this.selectedLink).filter((item) => {
            return this.selectedLink[item];
        });
    }

    deleteAllLinks(): void {
        this.deleteLink(this.selectedLinkDelete);
    }
 }
